import React, { useEffect, useState, useContext } from 'react'
import { useForm } from 'react-hook-form'
import deepEqual from 'deep-equal'
import formFieldParser, {
    formValidate,
    formInputSelector,
} from '../../../utils/form/formFieldParser'
import { PanelStyleContext } from '../panel/PanelStyleContext'
import { removeOrderAndPageParams } from '../../../utils/params'
import { ParameterContext } from '../../wrappers/ParameterContext'

const Form = ({
    formFields,
    onSubmit,
    onChange,
    onReset,
    formWidth,
    formName,
    addToResults,
    refineResults,
    params,
    isSectionCollapsible = false,
}) => {
    const {
        register,
        control,
        handleSubmit,
        setError,
        clearErrors: clearError,
        formState: { errors },
        getValues,
        setValue,
        trigger: triggerValidation,
        unregister,
        watch,
        reset,
    } = useForm({
        mode: 'onChange',
    })

    const { storedParams, refinedParams } = useContext(ParameterContext)
    const { backgroundColorClass } = useContext(PanelStyleContext)

    const fields = formFieldParser(
        formFields,
        register,
        unregister,
        control,
        getValues,
        setValue,
        setError,
        clearError,
        errors,
        formWidth,
        formName,
        backgroundColorClass,
        watch,
        formValidate,
        formInputSelector,
        isSectionCollapsible
    )

    const w = watch()
    const [formValues, setFormValues] = useState({})
    // const buttonSize = formWidth === 'full' ? 'is-normal' : 'is-small'
    const buttonSize = 'is-small'

    const formHasErrors = errors => {
        const hasErrors = Object.keys(errors)
            .map(errorKey => {
                const fieldErrors = errors[errorKey]
                if (typeof fieldErrors == 'object' && fieldErrors.length) {
                    if (fieldErrors.find(x => typeof x !== 'undefined')) {
                        return true
                    } else {
                        return false
                    }
                }
                return true
            })
            .find(x => x === true)
        return hasErrors
    }

    useEffect(() => {
        const snapshot = JSON.parse(JSON.stringify(w))

        // initialize form values
        if (Object.keys(w).length !== Object.keys(formValues).length) {
            setFormValues(snapshot)
        }

        // if the form state has updated, get the new results count
        if (Object.keys(w).length && !deepEqual(formValues, snapshot)) {
            if (!Object.keys(errors).length) {
                if (!formHasErrors(errors)) {
                    onChange(null, w)
                    setFormValues(snapshot)
                }
            }
        }
    }, [w])

    const cleanParams = removeOrderAndPageParams(params, formName)

    return (
        <div className="container formWrapper">
            <form
                noValidate
                onSubmit={handleSubmit(onSubmit)}
                className="columns is-multiline explorerForm full-width"
            >
                {fields}
                <div className="column is-full">
                    <div className="field is-horizontal is-grouped is-grouped-centered formSubmitWrapper">
                        <div className="control is-half">
                            <button
                                className={`button is-primary ${backgroundColorClass} ${buttonSize} formSubmitButton`}
                                type="submit"
                                onClick={e => {
                                    e.preventDefault()
                                    triggerValidation().then(() => {
                                        if (!formHasErrors(errors)) {
                                            handleSubmit(onSubmit)()
                                        }
                                    })
                                }}
                            >
                                Apply Filter
                            </button>
                        </div>
                        <div className="control is-half">
                            <button
                                className={`button is-secondary ${buttonSize} formSubmitButton`}
                                type="reset"
                                onClick={() => {
                                    onReset(getValues, setValue)
                                    reset()
                                    handleSubmit(onSubmit)
                                }}
                            >
                                Clear All Filters
                            </button>
                        </div>
                        <div className="control is-half">
                            <button
                                className={`button is-secondary ${buttonSize} formSubmitButton`}
                                type="submit"
                                disabled={
                                    (!Object.keys(cleanParams).length &&
                                        !(
                                            refinedParams &&
                                            refinedParams.length
                                        )) ||
                                    (refinedParams && refinedParams.length > 0)
                                }
                                onClick={e => {
                                    e.preventDefault()
                                    triggerValidation().then(() => {
                                        if (!formHasErrors(errors)) {
                                            handleSubmit(data =>
                                                addToResults(data, () => {
                                                    onReset(
                                                        getValues,
                                                        setValue,
                                                        false
                                                    )
                                                    reset()
                                                })
                                            )()
                                        }
                                    })
                                }}
                            >
                                Add to Results
                            </button>
                        </div>
                        {formName === 'sample' && (
                            <div className="control is-half">
                                <button
                                    className={`button is-secondary ${buttonSize} formSubmitButton`}
                                    type="submit"
                                    disabled={
                                        (!Object.keys(cleanParams).length &&
                                            !(
                                                storedParams &&
                                                storedParams.length
                                            )) ||
                                        (storedParams &&
                                            storedParams.length > 0)
                                    }
                                    onClick={e => {
                                        e.preventDefault()
                                        triggerValidation().then(() => {
                                            if (!formHasErrors(errors)) {
                                                handleSubmit(data =>
                                                    refineResults(data, () => {
                                                        onReset(
                                                            getValues,
                                                            setValue,
                                                            false
                                                        )
                                                        reset()
                                                    })
                                                )()
                                            }
                                        })
                                    }}
                                >
                                    Refine Results
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        </div>
    )
}

export default Form
